<template>
  <div class="content content-full gamification-page">
    <div class="page-inner">
      <div class="mb-2">
        <router-link to="/challenges" class="text-white">
          <i class="fa fa-chevron-left mr-1"></i> {{ $t('challenges') }}
        </router-link>
      </div>
      <div class="mt-3">
        <h2 class="fw-thin text-center text-xs-center text-sm-center text-md-left text-white">{{ $t('global_rankings') }}</h2>
      </div>
      <div class="mt-3">
        <select class="form-control genres-select mb-2" v-model="countryFilter" @change="changeFilters()">
          <option value="">{{ $t('all_countries') }}</option>
          <option v-for="(_country, index) in countries" :value="_country" v-bind:key="`country_${index}`">{{ _country }}</option>
        </select>
        <select class="form-control genres-select" v-model="genre" @change="changeFilters()">
          <option value="">{{ $t('all_genres') }}</option>
          <option v-for="(genre, index) in genres" :value="genre" v-bind:key="`genre_${index}`">{{ genre }}</option>
        </select>
      </div>
      <div class="card bg-dark text-white mt-4" v-if="loading">
        <div class="card-body text-center">
          <i class="fa fa-spinner fa-spin"></i>
        </div>
      </div>
      <div class="row mt-4" v-if="top10.length">
        <div class="col-sm-4" v-for="(item, index) in top10" v-bind:key="`rankingTop_${index}`">
          <div class="card card-round bg-dark card-profile">
            <div class="badge badge-success badge-pro" v-if="item.user && item.user.subscription">PRO</div>
            <div class="card-header">
              <div class="badge badge-primary badge-rank">
                # {{ page * (index + 1) }}
              </div>
              <div class="profile-picture">
                <div class="avatar avatar-xl">
                  <a :href="`https://indiefy.me/${item.key}`" target="_blank">
                    <img :src="item.cover_image_small || item.cover_image || defaultImage" onerror="this.src = '/static/img/img-placeholder-dark.jpg'" alt="..." class="avatar-img rounded-circle">
                  </a>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="user-profile text-center text-white">
                <div class="name">
                  <i v-if="page === 1 && index === 0" class="fa fa-crown text-warning mr-1"></i>
                  <a :href="`https://indiefy.me/${item.key}`" target="_blank" class="text-artist">
                    {{ item.name | truncate(30) }}
                  </a>
                </div>
                <div class="job text-light">
                  <span v-if="item.ranking">{{ item.ranking.rank }}</span> <i class="fa fa-circle text-dark ml-1 mr-1"></i> <router-link :to="{ path: '/challenges/rankings', query: { page: page , country: countryFilter, genre: item.main_genre } }" class="text-white">{{ item.main_genre }}</router-link>
                </div>
                <div class="desc">
                  <router-link :to="{ path: '/challenges/rankings', query: { page: page , country: item.legal_country, genre: genre } }" class="desc">
                    <img class="mr-2" width="16" :src="getCountryImage(item.legal_country)" onerror="this.src = '/static/img/countries/default.png'" alt="">{{ item.legal_country }}
                  </router-link>
                </div>
                <div class="view-profile">
                  <a :href="`https://indiefy.me/${item.key}`" target="_blank"  class="btn btn-gradient btn-sm btn-block">
                    <i class="fa fa-headphones"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card bg-dark text-white mt-4" v-if="rankings.length">
        <div class="table-responsive">
          <table class="table table-striped table-striped-bg-black mb-0">
            <thead>
              <tr>
                <th></th>
                <th>{{ $t('artist') }}</th>
                <th>{{ $t('main_genre') }}</th>
                <th>{{ $t('country') }}</th>
                <th>{{ $t('ranking') }}</th>
                <th>{{ $t('score') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in rankings" v-bind:key="`ranking_${index}`">
                <td>
                  <span v-if="!top10.length">
                    # {{ (page * 100) + (index + 1) }}
                  </span>
                  <span v-if="top10.length">
                    # {{ (index + 1) + top10.length }}
                  </span>
                </td>
                <td>
                  <span class="badge badge-success mr-1" v-if="item.user && item.user.subscription">PRO</span>
                  <a :href="`https://indiefy.me/${item.key}`" target="_blank" class="text-artist">
                    {{ item.name | truncate(30) }}
                  </a>
                </td>
                <td>
                  <router-link :to="{ path: '/challenges/rankings', query: { page: page , country: countryFilter, genre: item.main_genre } }" class="text-white">
                    {{ item.main_genre  }}
                  </router-link>
                </td>
                <td>
                  <router-link :to="{ path: '/challenges/rankings', query: { page: page , country: item.legal_country, genre: genre } }" class="text-white">
                    <img class="mr-1" width="16" :src="getCountryImage(item.legal_country)" onerror="this.src = '/static/img/countries/default.png'" alt=""> {{ item.legal_country }}
                  </router-link>
                </td>
                <td>
                  <span v-if="item.ranking">
                    {{ item.ranking.rank }}
                  </span>
                </td>
                <td>
                  <span v-if="item.ranking">
                    {{ item.ranking.score }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="text-right text-white mt-2 mb-3" v-if="rankings.length">
        <span class="email-pagination-indicator" v-if="total && limit">{{ $t('page') }} {{ page }} {{ $t('of') }} {{ Math.ceil(total/limit) }}</span>
        <span class="email-pagination-indicator" v-if="loading">
          <i class="fa fa-spinner fa-spin"></i>
        </span>
        <div class="btn-group ml-3 paginator">
          <router-link tag="button" :to="{ path: '/challenges/rankings', query: { page: page - 1, country: countryFilter, genre: genre  } }" class="btn btn-default" :disabled="page <= 1">
            <i class="fa fa-angle-left"></i>
          </router-link>
          <router-link tag="button" :to="{ path: '/challenges/rankings', query: { page: page + 1, country: countryFilter, genre: genre  } }" class="btn btn-default" :disabled="(page >= Math.ceil(total/limit))">
            <i class="fa fa-angle-right"></i>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import countries from '../data/countries'
import genres from '../data/genres'
import Filters from '../components/utils/filters'
import ArtistGamification from '../services/artistGamification'

export default {
  name: 'Rankings',
  data: function () {
    return {
      loading: true,
      page: 1,
      limit: 100,
      genre: '',
      rankings: [],
      top10: [],
      countryFilter: '',
      defaultImage: '/static/img/img-placeholder-dark.jpg',
      countries: _.map(countries, (country) => { return country.name }),
      genres: _.map(genres, (genre, key) => { return key }),
      user: {}
    }
  },
  watch: {
    $route (to, from) {
      this.initParams()
      this.getRankings()
    }
  },
  methods: {
    getCountryImage: function (countryName) {
      let country = _.find(countries, item => item.name === countryName)

      if (country) {
        return `/static/img/countries/${country.code}.png`
      } else {
        return `/static/img/countries/default.png`
      }
    },
    isMobile: function () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    getRankings: function () {
      this.loading = true
      this.top10 = []
      this.rankings = []

      ArtistGamification.artistList({ genre: this.genre, country: this.countryFilter, page: this.page - 1, limit: this.limit }).then(response => {
        this.total = response.data.total
        this.rankings = response.data.items

        if (this.page === 1) {
          let length = this.isMobile() ? 10 : 9
          this.top10 = this.rankings.splice(0, length)
        }

        this.loading = false
      })
    },
    showProModal: function () {
      window.swal({
        title: this.$t('pro_account_needed'),
        closeOnEsc: false,
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: this.$t('cancel'),
            visible: true,
            className: 'btn btn-default'
          },
          confirm: {
            text: this.$t('upgrade_now'),
            className: 'btn btn-success'
          }
        }
      }).then(result => {
        if (result) {
          this.$router.push('/upgrade?from=rankings')
        }
      })
    },
    changeFilters: function () {
      if (!this.user.subscription) {
        this.genre = ''
        this.countryFilter = ''

        this.showProModal()
        return
      }

      this.$router.push({ path: `/challenges/rankings`, query: { country: this.countryFilter, genre: this.genre, page: this.page } })
    },
    initParams: function () {
      if (this.$route.query.country) {
        this.countryFilter = this.$route.query.country
      }

      if (this.$route.query.genre) {
        this.genre = this.$route.query.genre
      }

      if (this.$route.query.page) {
        this.page = parseInt(this.$route.query.page)
      }
    }
  },
  created: function () {
    this.user = this.$user
    this.initParams()
    this.getRankings()
  },
  mounted: function () {
    window.scrollTo(0, 0)
  },
  filters: {
    truncate: Filters.truncate
  }
}
</script>
<style lang="scss" scoped>
.genres-select {
  background: #321c72;
  color: white;
  border: none;
}

.card-profile .card-header {
  height: 55px;
}

.card-profile .user-profile .name {
  font-size: 16px;
}

.card-profile .badge-rank {
  position: absolute;
  right: -4px;
  top: -4px;
  font-size: 16px !important;
}

.card-profile .badge-pro {
  position: absolute;
  left: -3px;
  top: -3px;
}

.text-artist {
  color: #13BBCD !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Rankings.vue